import React, { useEffect, useRef, useState } from 'react';
import fetchData from '../../ApiController/dataFetcher';
import Profile from './Profile';
import RadioGroup from './RadioGroup';
import Schedule from './Schedule';
import './Staff.css';
import { calculateAndFormatTimeRange } from '../calculateAndFormatTimeRange';

const Staff = ({
  courseId,
  setCourseId,
  setSelectedPersonSign,
  setSelectedSchedule,
}) => {
  const [schedules, setSchedules] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [tooltipVisible] = useState({});
  const [tooltipOffsets, setTooltipOffsets] = useState({});
  const [scheduleBookningId, setScheduleBookningId] = useState(null);
  const [previousSelected, setPreviousSelected] = useState({
    teacherId: null,
    bookingId: null,
  });
  const tooltipRefs = useRef({});
  const prevTooltipVisible = useRef(null);
  const [data, setData] = useState([])
  
  useEffect(() => {
    setPreviousSelected({
      teacherId: selectedEvent,
      bookingId: scheduleBookningId,
    });
  }, [selectedEvent, scheduleBookningId]);

  useEffect(() => {
    const fetchDataAndInitialize = async () => {
      try {
        const { teachers, scheduleData } = await fetchData();

        const newSchedules = teachers
          .map((teacher) => {
            let schedule = scheduleData?.filter((item) =>
              item.larareIKurs.includes(teacher.id)
            );
            const firstName = teacher.firstName;
            const lastName = teacher.lastName;
            const status = teacher.status;
            const profileImg = teacher.imgdata;
            return {
              teacherId: teacher.id,
              schedule,
              firstName,
              lastName,
              status,
              profileImg,
            };
          })
          .sort((a, b) => b.schedule.length - a.schedule.length);
          setData(scheduleData);

        const newTooltipRefs = {};
        newSchedules.forEach((teacherSchedule) => {
          if (Array.isArray(teacherSchedule.schedule)) {
            teacherSchedule.schedule.forEach((item) => {
              newTooltipRefs[item.bokningsId] = React.createRef();
            });
          }
        });

        setSchedules(newSchedules);
        tooltipRefs.current = newTooltipRefs;
      } catch (error) {
        console.error('Error fetching schedule:', error.message);
      }
    };

    fetchDataAndInitialize();

    const interval = setInterval(fetchDataAndInitialize, 300000); // 300000 ms = 5 minuter

    // Uppröjningsfunktion för att rensa intervallet
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (courseId !== null) {
      setSelectedEvent(null);
    } else if (
      tooltipVisible &&
      tooltipVisible !== prevTooltipVisible.current
    ) {
      const newTooltipOffsets = { ...tooltipOffsets };
      let shouldUpdateState = false;
      Object.keys(tooltipVisible).forEach((id) => {
        if (
          tooltipVisible[id] &&
          tooltipRefs.current[id] &&
          tooltipRefs.current[id].current
        ) {
          newTooltipOffsets[id] = tooltipRefs.current[id].current.offsetHeight;
          shouldUpdateState = true;
        }
      });

      if (shouldUpdateState) {
        setTooltipOffsets(newTooltipOffsets);
      }
    }

    prevTooltipVisible.current = tooltipVisible;
  }, [courseId, tooltipVisible, tooltipOffsets]);

  const minStartTime = () => calculateAndFormatTimeRange('min', 'startTid', data);
  const maxEndTime = () => calculateAndFormatTimeRange('max', 'slutTid', data);
  
  const clearSelectedPerson = () => {
    setSelectedPersonSign(null);
  };

  const clearSelectedSchedule = () => {
    setSelectedSchedule(null);
  };

  const clearCourseId = () => {
    setCourseId(null);
  };

  const clearScheduleBookingId = (bookingId, teacherId) => {
    setScheduleBookningId((prevSelectedEvent) =>
      prevSelectedEvent === bookingId &&
      teacherId === previousSelected.teacherId
        ? null
        : bookingId
    );
  };

  const profileClickHandler = (teacherId, bookingId) => {
    setSelectedPersonSign((prevSign) =>
      prevSign === teacherId ? null : teacherId
    );
    clearSelectedSchedule();
    clearCourseId();
    clearScheduleBookingId(bookingId);
  };

  const scheduleClickHandler = (teacherId, bookingId) => {
    setSelectedSchedule((prevSign) =>
      prevSign === bookingId && previousSelected.teacherId === teacherId
        ? null
        : bookingId
    );
    clearSelectedPerson();
    clearCourseId();
    setSelectedEvent((prevSelectedEvent) =>
      prevSelectedEvent === teacherId &&
      previousSelected.bookingId === bookingId
        ? null
        : teacherId
    );
    clearScheduleBookingId(bookingId, teacherId);
  };

  const convertToMinutes = (time) => {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  };

  return (
    <div className="staff-container">
	      {schedules.map((teacherSchedule, index) => {
        const { teacherId, schedule, firstName, lastName, status, profileImg } =
          teacherSchedule;
        const filteredSchedules = schedule?.filter((booking) => {
          const start = convertToMinutes(booking.startTid);
          const end = convertToMinutes(booking.slutTid);
          const dayStart = convertToMinutes(minStartTime());
          const dayEnd = convertToMinutes(maxEndTime());
          return start >= dayStart && end <= dayEnd;
        });

        return (
          <div key={teacherId} className="profile-scdual-wrapper">
            <Profile
              teacherId={teacherId}
              profileClickHandler={profileClickHandler}
              firstName={firstName}
              lastName={lastName}
              profileImg={profileImg}
            />
            <Schedule
              schedules={filteredSchedules}
              teacherId={teacherId}
              selectedEvent={selectedEvent}
              scheduleBookningId={scheduleBookningId}
              courseId={courseId}
              scheduleClickHandler={scheduleClickHandler}
              minStartTime={minStartTime}  
              maxEndTime={maxEndTime}  
            />
            <RadioGroup index={index} status={status} />
          </div>
        );
      })}
    </div>
  );
};
export default Staff;
